<template>
  <div
    class="
      tw-h-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-8
    "
  >
    <img
      class="sf-empty-state-image"
      :src="$imagesRequire('empty_states/communication.svg')"
    />
    <h2 class="tw-text-2xl tw-mt-0 tw-mb-2">
      {{
        I18n.t(
          'client_meetings.meeting_preparation.empty_state.no_messages_yet'
        )
      }}
    </h2>
    <p>
      {{
        I18n.t('client_meetings.meeting_preparation.empty_state.messages_using')
      }}
      <RemarkTag v-if="talkingPointTag" :tag="talkingPointTag" />
      {{
        I18n.t(
          'client_meetings.meeting_preparation.empty_state.tag_will_automatically_appear'
        )
      }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { RemarkTag as RemarkTagType } from '@app/shared/types/sf-data'

import useI18n from '@app/shared/vue/composables/use-I18n'
import RemarkTag from '@app/application/communication/sections/communication/components/remarks/remark-tag.vue'

const I18n = useI18n()

interface Props {
  talkingPointTag: RemarkTagType | undefined
}

defineProps<Props>()
</script>
